export default __webpack_public_path__ + "0c5a73e2db39162dc28d51d187f9e3b3.svg";